import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import {
  Grid,
  Row,
  Col,
  Table,
  FormControl,
  Pagination
} from "react-bootstrap";
import ReactSelect from 'react-select';

import Datetime from "react-datetime";

import LoadingSpinner from 'views/Components/loadingSpinner';
import Card from "components/Card/Card.jsx";

import { allActivityTracks, allActivityCodes } from '../../../Listfunction';

const ActivityDetails = () => {

    const [rows, setRows] = useState([]);
    const [activityCodeList, setActivityCodeList] = useState([])
    const [isLoading, setIsLoading] = useState(true);
    const [pageNumber, setPageNumber] = useState(0);
    const [resultCount, setResultCount] = useState(20);
    const [pageCount, setPageCount] = useState(0);
    const [pageArray, setPageArray] = useState([]);
    const [channel, setChannel] = useState('');
    const [application, setApplication] = useState('');
    const [mobile, setMobile] = useState('');
    const [selectedStartDate, setSelectedStartDate] = React.useState('')
    const [selectedEndDate, setSelectedEndDate] = React.useState('')
    const [activityCode, setActivityCode] = React.useState([]);
    let queue;
    let pageInitiator = 1;

    const [searchTerms, setSearchTerms] = useState({
        _entity: 'ActivityTrack',
        _select: '*',
        _page: 1,
      });
    
      const createDataForActivityList = (
        id,
        activityCode,
        mobile,
        application,
        channel,
        createdAt,
      ) => {
        return {
          id,
          activityCode,
          mobile,
          application,
          channel,
          createdAt,
        };
      };

      const createDataForActivityCodeList = (
        id,
        activityCode,
        title
      )=>{
        return {
          id:id,
          value:activityCode,
          label:activityCode
        }
      }

    const handleChange = (event) => {
        setActivityCode(event);
      };

    const createUserRows = useCallback(async () => {
        const res = await allActivityTracks(searchTerms);
        const resActivitiyCodes = await allActivityCodes()
        
        setIsLoading(true);
        const rows = [];
        const activityCodeList =[];
    
        if (res.status !== 'success') return [];
        if(resActivitiyCodes.status === 'success'){
          resActivitiyCodes.data.forEach(item => {
            activityCodeList.push(createDataForActivityCodeList(item.data,item.activityCode,item.title))
          })
        setActivityCodeList(activityCodeList)
        }else setActivityCodeList(activityCodeListSample);

        res.data.forEach(item => {
          const {
          id,
          activityCode,
          mobile,
          application,
          channel,
          createdAt,
          } = item;
          rows.push(
            createDataForActivityList(
              id,
              activityCode,
              mobile,
              application,
              channel,
              createdAt,
            ),
          );
        });
        const count = Math.ceil(res.meta.totalCount / 20);
        setRows(rows);
        setIsLoading(false);
        setPageNumber(res.meta.page);
        setResultCount(res.meta.resultCount);
        setPageCount(count);
        let list = [];
        for (var i = 1; i <= count; i++) {
        list.push(i);
        }
        setPageArray(list);
      }, [searchTerms]);
    
      useEffect(() => {
        createUserRows();
      }, [searchTerms]);

      const jumpPage = (page) => {
        setSearchTerms({
          ...searchTerms,
          ...{ _page: page },
        });
      };

      const prevPage = () => {
        setSearchTerms({
          ...searchTerms,
          ...{ _page: searchTerms._page - 1 },
        });
      };
    
      const nextPage = () => {
          setSearchTerms({
          ...searchTerms,
          ...{ _page: searchTerms._page + 1 },
        });
      };
    
      useEffect(() =>{
            const updatedSearchTerms = {
          ...searchTerms,
        }
        if (selectedStartDate>0){
            updatedSearchTerms['startDate'] = moment(selectedStartDate).format('YYYY-MM-DDTHH:mm')
        } else {
          delete updatedSearchTerms['startDate'];
        }
        setSearchTerms(updatedSearchTerms);
      },[selectedStartDate])
    
      useEffect(() =>{
        const updatedSearchTerms = {
          ...searchTerms,
        }
        if (selectedEndDate>0){
          updatedSearchTerms['endDate'] = moment(selectedEndDate).format('YYYY-MM-DDTHH:mm')
        } else {
          delete updatedSearchTerms['endDate'];
        }
        setSearchTerms(updatedSearchTerms);
      },[selectedEndDate])
    
      useEffect(() => {
        const updatedSearchTerms = {
          ...searchTerms,
        };
        if (activityCode.length>0) {
            let activityCodeValues = []
            activityCode.forEach(val=>activityCodeValues.push(val.value))
          updatedSearchTerms['activityCode'] = activityCodeValues.join('-');
        } else {
          delete updatedSearchTerms['activityCode'];
        }
        setSearchTerms(updatedSearchTerms);
      }, [activityCode]);
    
      useEffect(() => {
        const updatedSearchTerms = {
          ...searchTerms,
        };
    
        if (!mobile) {
          delete updatedSearchTerms['mobile'];
          setSearchTerms(updatedSearchTerms);
        }
    
        if (mobile.length > 2) {
          updatedSearchTerms['mobile'] = mobile;
          clearTimeout(queue);
          queue = setTimeout(() => {
            setSearchTerms(updatedSearchTerms);
          }, 500);
        }
      }, [mobile]);
    
      useEffect(() => {
        const updatedSearchTerms = {
          ...searchTerms,
        };
        if (application.length) {
          updatedSearchTerms['application'] = application;
        } else {
          delete updatedSearchTerms['application'];
        }
        setSearchTerms(updatedSearchTerms);
      }, [application]);
    
      useEffect(() => {
        const updatedSearchTerms = {
          ...searchTerms,
        };
        if (channel.length) {
          updatedSearchTerms['channel'] = channel;
        } else {
          delete updatedSearchTerms['channel'];
        }
        setSearchTerms(updatedSearchTerms);
      }, [channel]);

    return (
        <div className="main-content">
        <Grid fluid>
        <Row>
            <Col md={12}>
              <Card
                tableFullWidth
                content={
                  <Row>
                <br></br>
                <Row className="OrderList_fill"  
                style={{ borderRadius:"5px", paddingTop:"10px", paddingBottom:"10px",  width:"98%", marginLeft:"7px"}}>
                <Col md={3} sm={4} lg={1}  xs={12} className="fl_mb_1" 
                style={{paddingTop:"4px", width:"28%"}} >
                <ReactSelect
                    placeholder="Activity Code"
                    isMulti
                    value={activityCode}
                    onChange={handleChange}
                    options={activityCodeList}
                    theme={theme => ({
                    ...theme,
                    borderRadius: 10,
                    colors: {
                        ...theme.colors,
                        // primary25: 'red',
                        primary: 'black',
                    },
                    })}
                />
                </Col>
                <Col md={3} sm={4} lg={1}  xs={12} className="fl_mb_1"  style={{paddingLeft:"18px", width:"14%"}}  >
                    <FormControl  
                    name="Mobile" value={mobile ||''} 
                    placeholder="Mobile" type="text"
                    onChange={ev => setMobile(ev.target.value)} 
                    />
                </Col>
                <Col md={3} sm={4} lg={1}  xs={12} className="fl_mb_1"  style={{paddingLeft:"18px", width:"14%"}}  >
              <Datetime
                    dateFormat="YYYY-MM-DD"
                    inputProps={{ placeholder: "Start Date" }}
                    closeOnSelect={true}
                    value={selectedStartDate}
                    onChange={val=>{
                        setSelectedStartDate(val._d)
                      }}
                  />
              </Col>
                <Col md={3} sm={4} lg={1}  xs={12} className="fl_mb_1"  style={{paddingLeft:"14px", width:"14%"}}  >
              <Datetime
                  dateFormat="YYYY-MM-DD"
                  inputProps={{ placeholder: "End Date" }}
                  closeOnSelect={true}
                  value={selectedEndDate}
                  onChange={val=>{
                    setSelectedEndDate(val._d)
                  }}
                />
                </Col>
                <Col md={3} sm={4} lg={1}  xs={12} className="fl_mb_1" style={{paddingTop:"4px", width:"14%"}} >
                <select name="Application"  
                onChange={ev => setApplication(ev.target.value)} 
                value={application} className="form-control">
                    <option value="">Application</option>
                    {applications.map(element => <option value={element.value} >{element.value}</option>)}
                    </select>
                </Col>
              <Col md={3} sm={4} lg={1}  xs={12} className="fl_mb_1" style={{paddingTop:"4px", width:"14%"}}>
              <select name="Channel"  
              onChange={ev => setChannel(ev.target.value)} 
              value={channel} className="form-control">
                    <option value="">Channel</option>
                    {activityChannels.map(element=><option value={element.value}>{element.value}</option>)}
                  </select>
              </Col>
              </Row>
                <br></br>
                    <Col md={12} sm={12} lg={12}  xs={12}>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>Date & Time</th>
                        <th>Activity Code</th>
                        <th>Mobile No</th>
                        <th>Application</th>
                        <th>Channel</th>
                        {/*<th className="text-right">Actions</th>*/}
                      </tr>
                    </thead>
                    <tbody>
                    {isLoading ? <tr><td colspan="10"><LoadingSpinner /></td></tr> : 
                    !resultCount ? <tr><td colspan="10"><center>No record found</center></td></tr> :

                        <React.Fragment>
                          {rows.map(element => {
                              return (<tr>
                              <td>{moment(element.createdAt).format("YYYY-MM-DD HH:MM")}</td>
                              <td>{element.activityCode}</td>
                              <td>{element.mobile}</td>
                              <td>{element.application}</td>
                              <td>{element.channel}</td>
                              </tr>)
                            })}
                        </React.Fragment>
                      }
                    </tbody>
                  </Table>
                  {
                  isLoading ? "" : 
                  !resultCount ? "" : 
                  <div style={{textAlign:'center'}} 
                  >
                  {<Pagination>
                        <Pagination.First dataUrl={pageNumber-1} onClick={()=>(pageNumber>1)?prevPage():null} disabled={pageNumber<=1} />
                        {pageArray.map((url) => (<Pagination.Item  dataUrl={url} active={pageNumber==pageInitiator?"1":null} onClick={()=>jumpPage(url)} >{pageInitiator++}</Pagination.Item>
                        ))}
                        <Pagination.Last  dataUrl={pageNumber+1} 
                        onClick={()=>(pageNumber<pageCount)?nextPage():null} 
                        disabled={pageNumber>=pageCount} />
                        </Pagination>}
                      </div>
                }
                  </Col>
                </Row>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
}

export default ActivityDetails;

const activityCodeListSample=[
    {
      "id":1,
      "label":"ACT_CODE_1",
      "value":"ACT_CODE_1"
    },
    {
      "id":2,
      "label":"ACT_CODE_2",
      "value":"ACT_CODE_2"
    },
    {
      "id":3,
      "label":"ACT_CODE_3",
      "value":"ACT_CODE_3"
    }
  ]
  const activityChannels=[
    {
      "id":1,
      "label":"BOT",
      "value":"BOT"
    },
    {
      "id":2,
      "label":"APP",
      "value":"APP"
    },
    {
      "id":3,
      "label":"WEB",
      "value":"WEB"
    }
  ]
  const applications=[
    {
      "id":1,
      "label":"Website",
      "value":"Website"
    },
    {
      "id":2,
      "label":"RiderApp",
      "value":"RiderApp"
    },
    {
      "id":3,
      "label":"CustomerApp",
      "value":"CustomerApp"
    }
  ]
